import styled from 'styled-components'

export const SmallTable = styled.table`
  border-collapse: collapse;
  color: #fff;
  width: 100%;
  * {
    text-align: start;
  }

  tbody tr td {
    font-size: 14px;
    color: ${(props) => props.theme.textColor};
    padding: 8px 0;
    border-top: 1px solid #ffffff20;
    line-height: 20px;
  }
`

export const SmallThead = styled.thead`
  font-weight: bold;
  color: ${(props) => props.theme.textColor};

  th {
    padding-bottom: 14px;
    line-height: 18px;
    font-size: 14px;
  }
`
